import React from 'react';

import {Button, Stack, Typography} from '@mui/material';
import {AddressData} from 'presentation/utils';
import {translations} from 'presentation/translations-new';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';

const {openMap} = translations['pt-br'].privateFlow.guideFlow.addressItemLabel;

export const RenderAddressField = ({formattedAddress, addressForMaps}: AddressData) => {
	const handleOpenGoogleMaps = () => openGoogleMaps(addressForMaps || '');

	return (
		<Stack gap={1}>
			<Typography variant="body2" color="text.secondary">
				{formattedAddress}
				{' - '}
				<Button
					variant="text"
					sx={{p: 0, textDecoration: 'underline', lineHeight: 'normal'}}
					onClick={handleOpenGoogleMaps}>
					{openMap}
				</Button>
			</Typography>
		</Stack>
	);
};
